package br.gov.go.pge.permanenciaweb.site.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.browser.dom.observers.IntersectionObserver
import com.varabyte.kobweb.compose.dom.disposableRef
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.width
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

/*
 * Invisible 1px sentinel after the events table: an `IntersectionObserver` asks for one more batch
 * as soon as it scrolls into view (192px = 12rem early via rootMargin). The ref is keyed on the derived
 * rows list, so changing filters/sort rebuilds the observer instead of re-firing.
 *
 * Escape hatch: Silk has no infinite-scroll primitive; the observer is created inside the ref
 * effect, so the export prerender never touches `window` at composition time.
 */
@Composable
internal fun LoadMoreSentinel(resetKey: Any?, onLoadMore: () -> Unit) {
    Box(
        modifier = Modifier
            .width(100.percent)
            .height(1.px)
            // Stable hook for UI tests (see `LoadMoreSentinelTest`).
            .id("load-more-sentinel"),
        ref = disposableRef(resetKey) { element ->
            val observer = IntersectionObserver(
                // rootMargin only accepts px/% (rem throws a DOMException) — 192px = 12rem at the 16px base.
                IntersectionObserver.Options(rootMargin = "0px 0px 192px 0px"),
            ) { entries ->
                if (entries.any { it.isIntersecting }) onLoadMore()
            }
            observer.observe(element)
            onDispose { observer.disconnect() }
        },
    )
}
